import { logRocketEnvironmentIdFactory } from '../factories/logrocket-enviornment-id.factory';
import { LOGROCKET_ENVIRONMENT_ID } from '../tokens/logrocket-enviroment-id.token';
import { WINDOW } from '../tokens/window.token';
import { FactoryProvider } from '@angular/core';

export const LOGROCKET_ENVIRONMENT_ID_PROVIDER: FactoryProvider = {
  deps: [WINDOW],
  provide: LOGROCKET_ENVIRONMENT_ID,
  useFactory: logRocketEnvironmentIdFactory,
};
